__turbopack_context__.v({
  "fixedImage": "ihoNBq_fixedImage",
  "root": "ihoNBq_root",
});
